import { SEARCHLIGHT_ACTION_TYPE } from 'a/actions/searchlightActionCreators';
import { SEARCHLIGHT_EVENT_TYPE } from 'root/lib/SearchlightDispatcher';

export const PROGRESS_TYPE = {
  CLOSE_READING: 'close_reading',
  EREADER: 'ereader',
  VOCAB: 'vocabulary',
  SKILL_GAME: 'skill_game',
};

const initialState = {
  lastAppLaunched: '',
  lastGamePlayed: '',
  lastLevelSummary: {},
};

const studentProgressReducer = (state = initialState, { type, payload }) => {
  if (type === 'SELECT_ACTIVITY') {
    return {
      ...state,
      lastLevelSummary: {},
    };
  }

  switch (type) {
    case 'CLEAR_LAST_LEVEL_SUMMARY':
    case 'SELECT_ACTIVITY':
      return {
        ...state,
        lastLevelSummary: {},
      };

    case 'SET_LAST_APP_LAUNCHED':
      return {
        ...state,
        lastAppLaunched: payload,
      };

    case 'LOAD_SESSION_PROGRESS': {
      const { lastAppLaunched = '' } = payload;
      return {
        ...state,
        lastAppLaunched,
      };
    }
    case 'CLEAR_SESSION_PROGRESS': {
      return { ...initialState };
    }
    default:
      break;
  }

  if (type !== SEARCHLIGHT_ACTION_TYPE.SEARCHLIGHT_DISPATCH_EVENT) {
    return state;
  }

  const { eventType, details, gameId } = payload.application;
  switch (eventType) {
    case SEARCHLIGHT_EVENT_TYPE.REPEAT_ONBOARDING:
    case SEARCHLIGHT_EVENT_TYPE.ONBOARDING_START:
    case SEARCHLIGHT_EVENT_TYPE.ROUND_START: {
      return {
        ...state,
        lastLevelSummary: {},
      };
    }
    case SEARCHLIGHT_EVENT_TYPE.NAVIGATION: {
      return {
        ...state,
        lastLevelSummary: details.destinationGroup === 'game' ? {} : state.lastLevelSummary,
      };
    }
    case SEARCHLIGHT_EVENT_TYPE.ROUND_COMPLETE: {
      const { isEarlyExit, skipSummary = false } = details;
      const { summaryScreenData = {} } = details;
      return {
        ...state,
        lastGamePlayed: gameId,
        lastLevelSummary: !isEarlyExit && !skipSummary ? {
          ...state.lastLevelSummary,
          gameId,
          levelIndex: details.level - 1, // going from levelId (1 based) to index (0 based)
          correctCount: summaryScreenData.correctCount ?? details.questionsCorrect,
          totalCount: summaryScreenData.totalCount ?? details.questionCount,
          showSummaryData: true, // correctCount / totalCount
        } : {},
      };
    }

    case SEARCHLIGHT_EVENT_TYPE.LEVEL_COMPLETE: {
      const { isSuccess } = details;
      return {
        ...state,
        lastLevelSummary: {
          ...state.lastLevelSummary,
          isSuccess,
          isRoundEnd: true,
        },
      };
    }

    default:
      return state;
  }
};

export default studentProgressReducer;
